module.exports = __webpack_public_path__ + "static/media/banner--2.99a7d7c4.jpg";